import { SortDescriptor } from "react-aria-components";

import { BlueprintIntegrationAttachment } from "types/generated";

import { INTEGRATION_USED_BY_COLUMN_ID } from "./constants";

export const sortIntegrationUsedBy = (
  blueprints: BlueprintIntegrationAttachment[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return blueprints;
  }

  const isAscending = sortDescriptor.direction === "ascending";

  return [...blueprints].sort((a, b) => {
    let valueA: string | undefined;
    let valueB: string | undefined;

    switch (sortDescriptor.column as INTEGRATION_USED_BY_COLUMN_ID) {
      case INTEGRATION_USED_BY_COLUMN_ID.NAME:
        valueA = a.blueprintName;
        valueB = b.blueprintName;
        break;
      case INTEGRATION_USED_BY_COLUMN_ID.SPACE:
        valueA = a.blueprintSpaceDetails?.name;
        valueB = b.blueprintSpaceDetails?.name;
        break;
      case INTEGRATION_USED_BY_COLUMN_ID.DROPDOWN:
        break;
    }

    valueA = valueA || "";
    valueB = valueB || "";

    return isAscending
      ? valueA.localeCompare(valueB, undefined, { numeric: true })
      : valueB.localeCompare(valueA, undefined, { numeric: true });
  });
};
